import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from './AuthContext';
import './HomePage.css';

const sessions = [
  {
    id: 'emotion',
    icon: '😊',
    iconBg: '#FFF3E0',
    title: 'Emotion Corner',
    desc: 'Start a guided learning session with fun images and exercises.',
    route: '/emotion-corner',
    available: true,
  },
  {
    id: 'fruits',
    icon: '🍉',
    iconBg: '#FCE4EC',
    title: 'Fruits Identifier',
    desc: 'Start a guided learning session with fun images and exercises.',
    route: '/fruits',
    available: true,
  },
  {
    id: 'vegetables',
    icon: '🥕',
    iconBg: '#FFF8E1',
    title: 'Vegetables Identifier',
    desc: 'Start a guided learning session with fun images and exercises.',
    route: '/vegetables',
    available: true,
  },
  {
    id: 'animals',
    icon: '🐾',
    iconBg: '#F3E5F5',
    title: 'The Animals Identifier',
    desc: 'Start a guided learning session with fun images and exercises.',
    route: '/animals',
    available: true,
  },
  {
    id: 'sports',
    icon: '🎨',
    iconBg: '#E8F5E9',
    title: 'Sports Identifier',
    desc: 'Start a guided learning session with fun images and exercises.',
    route: '/sports',
    available: true,
  },
];

const ADMIN_CARDS = [
  {
    id: 'hospitals',
    icon: '🏥',
    iconBg: '#E0F2FE',
    title: 'Hospital Locations',
    desc: 'Manage hospital names and locations used in child sessions.',
    route: '/hospitals',
  },
  {
    id: 'users',
    icon: '👥',
    iconBg: '#F0FDF4',
    title: 'Manage Users',
    desc: 'Create and manage practitioner and admin accounts.',
    route: '/users',
  },
  {
    id: 'sessions',
    icon: '📋',
    iconBg: '#FEF3C7',
    title: 'All Sessions',
    desc: 'View all child sessions and their detailed reports.',
    route: '/sessions',
  },
  {
    id: 'gallery',
    icon: '🖼️',
    iconBg: '#F3E8FF',
    title: 'Emotion Gallery',
    desc: 'Upload and manage emotion reference images used in Pre/Post Tests.',
    route: '/gallery',
  },
];

function HomePage() {
  const navigate = useNavigate();
  const { user, logout } = useAuth();
  const isAdmin = user?.role === 'admin';

  const handleStart = (session) => {
    if (session.available) {
      navigate(session.route);
    }
  };

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <div className="home-shell">
      {/* Header with user info and logout */}
      <header className="home-header">
        <div className="home-brand">
          <span className="home-logo-icon">🧠</span>
          <span className="home-brand-name">Feelio</span>
        </div>
        {user && (
          <div className="home-user-section">
            <span className="home-user-greeting">
              👋 Hi, {user.name}!
            </span>
            {!isAdmin && (
              <button
                onClick={() => navigate('/sessions')}
                style={{
                  background: '#EFF6FF', border: '1.5px solid #BFDBFE', borderRadius: '12px',
                  padding: '8px 14px', fontSize: '14px', fontWeight: '700', color: '#2563EB',
                  cursor: 'pointer', fontFamily: 'Segoe UI, Inter, sans-serif',
                }}
              >
                📋 My Sessions
              </button>
            )}
            <button
              className="home-logout-btn"
              onClick={handleLogout}
              title="Logout"
            >
              🚪 Logout
            </button>
          </div>
        )}
      </header>

      {/* Hero ── */}
      <div className="home-hero">
        <div className="home-logo">🧠</div>
        <h1 className="home-title">Feelio</h1>
        <p className="home-subtitle">
          A gentle, AI-powered learning companion for children to explore and
          understand emotions and etc.
        </p>
      </div>

      {/* Admin panel ── */}
      {isAdmin && (
        <>
          <div style={{
            width: '100%',
            maxWidth: '900px',
            textAlign: 'left',
            marginBottom: '8px',
          }}>
            <h2 style={{ fontSize: '16px', fontWeight: '700', color: '#6B7280', margin: 0, letterSpacing: '0.5px', textTransform: 'uppercase' }}>
              🔐 Admin Panel
            </h2>
          </div>
          <div className="home-grid" style={{ marginBottom: '16px' }}>
            {ADMIN_CARDS.map((s) => (
              <div key={s.id} className="home-card">
                <div className="home-card-icon" style={{ background: s.iconBg }}>{s.icon}</div>
                <h2 className="home-card-title">{s.title}</h2>
                <p className="home-card-desc">{s.desc}</p>
                <button className="home-start-btn" onClick={() => navigate(s.route)}>
                  ▶ Manage
                </button>
              </div>
            ))}
          </div>
        </>
      )}

      {/* Cards grid — practitioners only */}
      {!isAdmin && (
        <div className="home-grid">
          {sessions.map((s) => (
            <div key={s.id} className={`home-card ${!s.available ? 'home-card--dim' : ''}`}>
              <div className="home-card-icon" style={{ background: s.iconBg }}>
                {s.icon}
              </div>
              <h2 className="home-card-title">{s.title}</h2>
              <p className="home-card-desc">{s.desc}</p>
              <button
                className="home-start-btn"
                onClick={() => handleStart(s)}
                disabled={!s.available}
              >
                ▶ Start Session
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default HomePage;
